import React from 'react';
import TextField from '@mui/material/TextField';
import { getEventTypeConfig } from '../utils/eventTypes';
import FormDialog from './FormDialog';

/**
 * EditEventDialog - Dialog for editing event descriptions
 * @param {boolean} open - Whether the dialog is open
 * @param {Object} event - Event being edited
 * @param {string} description - Current description value
 * @param {Function} onDescriptionChange - Callback when description changes
 * @param {Function} onClose - Callback when dialog is closed
 * @param {Function} onSave - Callback when save is confirmed
 * @param {boolean} loading - Whether save is in progress
 */
export default function EditEventDialog({
  open,
  event,
  description,
  onDescriptionChange,
  onClose,
  onSave,
  loading = false
}) {
  if (!event) return null;

  const config = getEventTypeConfig(event.eventType);
  const isNote = event.eventType === 'note';

  return (
    <FormDialog
      open={open}
      title={`Edit ${config.label}`}
      onClose={onClose}
      onConfirm={onSave}
      confirmLabel="Save"
      loading={loading}
    >
      <TextField
        autoFocus
        margin="dense"
        label="Description"
        fullWidth
        multiline={isNote}
        rows={isNote ? 4 : 1}
        variant="outlined"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        disabled={loading}
      />
    </FormDialog>
  );
}
